import {
  SAVE_MESSAGE,
  SAVE_ACTIVE_SUPPORT_USER,
  SAVE_SUPPORT_USER_MESSAGES,
  SAVE_SUPPORT_USER_MORE_MESSAGES,
} from '../actions/activeUser'

const initialState = {
  botActive: null,
  chatId: null,
  chatStatus: null,
  firstName: null,
  lastMessage: null,
  lastName: null,
  messageDatetime: null,
  openedAt: null,
  platform: null,
  postback: null,
  profilePic: null,
  supportRequest: null,
  unreadMessage: null,
  unreadMessages: null,
  userId: null,
  userMessageDatetime: null,
  messages: [],
}

const activeUser = (state = initialState, { type, payload }) => {
  switch (type) {
  case SAVE_ACTIVE_SUPPORT_USER:
    return {
      ...state,
      ...payload.activeUser,
      messages: state.messages,
    }

  case SAVE_SUPPORT_USER_MESSAGES:
    return {
      ...state,
      messages: payload.messages,
    }

  case SAVE_SUPPORT_USER_MORE_MESSAGES:
    return {
      ...state,
      messages: [...state.messages, ...payload.messages]
    }

  case SAVE_MESSAGE:
    return {
      ...state,
      messages: [payload.message, ...state.messages],
    }

  default:
    return state
  }
}

export default activeUser
